import { render, staticRenderFns } from "./CreateUserDataModal.vue?vue&type=template&id=50a9a47d&"
import script from "./CreateUserDataModal.vue?vue&type=script&lang=js&"
export * from "./CreateUserDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports